import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "landingLeadName", "8888", "9999"]

  connect() {
    this.controllerName = `commercial--marketing--landings--conversions--list`
    this.itemsOnPage = 100
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `desc`, field: `converted_at_to_time` }
    this.hasShow = false
  }

  viewConversion(ev) {
    var id = ev.currentTarget.closest(".itemRow").dataset.id

    this.application.conversions.forEach(element => {
      if (element.id == id) {
        this.getControllerByIdentifier("commercial--marketing--landings--conversions--save").actionMode = `edit`
        this.getControllerByIdentifier("commercial--marketing--landings--conversions--save").current_conversion = element
        this.getControllerByIdentifier("commercial--marketing--landings--conversions--save").doFormHtml()
      }
    })
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Todas as Inscrições</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">
                                Data
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="converted_at_to_time" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="converted_at_to_time" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle">
                                Nome
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle">
                                E-mail
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">
                                Telefone
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">
                                Fonte
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="date_to_time" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="date_to_time" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Aparelho</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Tipo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle text-center"></th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("commercial--marketing--landings--conversions--dashboard").listTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(8, 6))
      controller.doDataTable()
      // if (controller.application.conversions.length > 0) {
      // }
    })
  }

  doDataTable() {
    var current_conversions = this.application.conversions

    if (this.sort.mode == `asc`) {
      var conversions = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_conversions, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var conversions = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_conversions, this.sort.field)
    }

    if (conversions.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(conversions.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (conversions[x] !== undefined) {
            internPage[internPage.length] = conversions[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: conversions.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="8" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Inscrições</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.conversionTablePartial(element, data.length))
      })
    }
  }

  conversionTablePartial(element, length) {

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    var searchBtn = `<button data-action="click->${this.controllerName}#searchCRM" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                        <span class="material-icons md-sm md-dark">search</span>
                        <span class="mc-tooltiptext">Procurar CRM</span>
                      </button>`
  
    if (element.utm_mc_source && element.utm_mc_campaign) {
      var source = `${element.utm_mc_campaign}#${element.utm_mc_source}`
    } else if (element.utm_mc_campaign) {
      var source = `${element.utm_mc_campaign}`
    } else if (element.utm_mc_source) {
      var source = `${element.utm_mc_source}`
    }

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#viewConversion">
                      <span class="mc-tooltip">
                        <span class="pointer">${element.converted_at_pretty}</span>
                        <span class="mc-tooltiptext">Mais Detalhes</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#viewConversion">
                      <span class="mc-tooltip">
                        <span class="pointer">${element.name}</span>
                        <span class="mc-tooltiptext">Mais Detalhes</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">
                      <p class="mb-0 mc-tooltip pointer">
                        <span data-controller="app--helpers--copy" data-copy="${element.email}" data-action="click->app--helpers--copy#copy">${element.email}</span>
                        <span class="mc-tooltiptext">Clique para Copiar</span>
                      </p>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      <p class="mb-0 mc-tooltip pointer">
                        <span data-action="click->${this.controllerName}#sendWhatsAppApi" class="f-normal f-1"><i class="fab fa-whatsapp white-text mr-2"></i></span>
                        <span class="mc-tooltiptext">Clique para enviar WhatsApp</span>
                      </p>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${source}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.device}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.kind_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${searchBtn}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="card-actions align-items-center justify-content-end py-0 f-065">
                        <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                        <div class="dropdown">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${pagination.itemsOnPage}</button>
                          <div class="dropdown-menu dropdown-menu-right menu">
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="100">100</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="250">250</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="500">500</span>
                          </div>
                        </div>
                        <span class="align-self-center mb-1 mr-2 text-muted">${pagination.fromItem}-${pagination.toItem} de ${pagination.totalItems}</span>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  searchCRM(ev) {
    var conversionId = ev.currentTarget.closest(".itemRow").dataset.id

    var lead = {}
    this.application.conversions.forEach(element => {
      if (element.id == conversionId) {
        lead = element
      }
    })

    if (lead.crm && lead.crm_state) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=&uf=${lead.crm_state}&crm=${lead.crm}&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    } else if (lead.crm) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=&uf=&crm=${lead.crm}&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    } else if (lead.name && lead.crm_state) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=${lead.name}&uf=${lead.crm_state}&crm=&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    } else if (lead.name) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=${lead.name}&uf=&crm=&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    }
  }


  sendWhatsAppApi(ev) {
    var conversionId = ev.currentTarget.closest(`.itemRow`).dataset.id
    var currentConversion = {}

    this.application.conversions.forEach(element => {
      if (element.id == conversionId) {
        currentConversion = element
      }
    })

    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).record_id = this.application.landing.id
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).record_type = `marketing_landings`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).record_name = `Landing ${this.application.landing.name}`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).obj_id = this.application.landing.id
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).obj_type = `marketing_landings`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).person_id = currentConversion.lead_id
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).person_type = `marketing_landing_leads`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).person_name = currentConversion.name
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).account_id = this.application.current_user.account_id
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).account_name = this.application.current_user.name
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).ddd = currentConversion.ddd
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).number = currentConversion.number
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).uniq_number = `${currentConversion.ddd}${currentConversion.number}`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).kind = `whatsapp`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).subkind = `active`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).permission = `landings`
    this.getControllerByIdentifier(`app--helpers--whatsapp-api`).requestSaveInteraction()
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
